import ContentLayout from '../../components/ContentLayout/ContentLayout'
import ImageContainer from '../../components/ImageContainer/ImageContainer'
import ErrorContent from '../../components/ErrorContent/ErrorContent'

export default function NotFoundPage() {
	return (
		<ContentLayout
			LeftSide={<ImageContainer src="/assets/images/error-house.png" width="60%" />}
			RightSide={
				<ErrorContent
					errorCode="404_error.code"
					errorHeader="404_error.header"
					errorMessage="404_error.message"
				/>
			}
		/>
	)
}
